// Lib
import React from 'react';
import { get } from 'lodash/fp';

// Components
import DefaultErrorRenderer from '../../components/error/errorBoundary/DefaultErrorRenderer';

// Styles
import './InboxErrorRenderer.scss';

const getErrorDetails = ({ element, error, currentBoardId }) =>
    `The inbox for board "${currentBoardId}" could not be rendered.

Timestamp: ${new Date().toISOString()}
Error: ${error && error.toString()}
Stack: ${get('stack', error)}`;

const InboxErrorRenderer = (props) => (
    <DefaultErrorRenderer
        {...props}
        className="InboxErrorRenderer"
        heading="Something went wrong in Unsorted Notes"
        furtherDetails={
            <ul>
                <li>What you were doing when the issue occurred</li>
                <li>If this error happens to all boards or just this board</li>
                <li>Any other details that you think will help</li>
                <li>Please also paste in the error below:</li>
            </ul>
        }
        getErrorDetails={getErrorDetails}
    />
);

export default InboxErrorRenderer;
